
import { Options, Vue } from 'vue-class-component'

import { clamp } from '@/util/math'

@Options({
    name: 'NotepadWindow',
    props: {
        zIndex: { required: true },
    },
    data: function (): any {
        return {
            transformations: {
                clientX: 0,
                clientY: 0,
                movementX: 0,
                movementY: 0,
                zoom: 1,
            },
            placeholder: `Welcome to Passive Aggresive Clippy.

Clippy is back and he's here to help you (albeit passive-aggressively) with your emails – so that you can be absolutely sure your messages are as friendly as humanely possible (which is probably not that much). Go ahead and type away with your beautiful words - watch for the highlighted sections and click them, so that Clippy can help you with the rest!
                
This is a small project as a tribute to the wonderful things I've read in the corporate email thread lifecycles. Here is to me hoping that my friends and co-workers will stumble upon a tool to help them notice the little things.
                `,
        }
    },
    mounted: function () {
        this.setDraggablePosition(
            window.innerWidth - 750,
            0.4 * window.innerHeight * Math.random(),
        )
    },
    methods: {
        windowBarDrag: function (event: MouseEvent) {
            this.transformations.clientX = event.clientX
            this.transformations.clientY = event.clientY
            document.onmousemove = (event: MouseEvent) => {
                event.preventDefault()
                this.setDraggablePosition(event.clientX, event.clientY)
            }
            document.onmouseup = () => {
                document.onmouseup = null
                document.onmousemove = null
            }
        },
        windowScaleDrag: function (event: MouseEvent) {
            this.transformations.clientX = event.clientX
            this.transformations.clientY = event.clientY
            document.onmousemove = (event: MouseEvent) => {
                event.preventDefault()
                this.setScale(event.clientX, event.clientY)
            }
            document.onmouseup = () => {
                document.onmouseup = null
                document.onmousemove = null
            }
        },
        setDraggablePosition: function (x: number, y: number) {
            this.transformations.movementX =
                x <= 0 || x >= innerWidth ? 0 : this.transformations.clientX - x
            this.transformations.movementY =
                y <= 0 || y >= innerHeight
                    ? 0
                    : this.transformations.clientY - y
            this.transformations.clientX = x
            this.transformations.clientY = y

            this.$refs.draggable.style.top =
                this.$refs.draggable.offsetTop -
                this.transformations.movementY +
                'px'
            this.$refs.draggable.style.left =
                this.$refs.draggable.offsetLeft -
                this.transformations.movementX +
                'px'
        },
        setScale: function (x: number, y: number) {
            this.transformations.movementX = this.transformations.clientX - x
            this.transformations.movementY = this.transformations.clientY - y
            this.transformations.clientX = x
            this.transformations.clientY = y

            this.transformations.zoom = clamp(
                this.transformations.zoom +
                    0.01 * -Math.sign(this.transformations.movementX),
                0.75,
                1.5,
            )
            this.$refs.draggable.style.zoom = this.transformations.zoom
        },
    },
})
export default class NotepadWindow extends Vue {}
